'use client'

// imports
import { useState } from 'react';

// lib files
import { StationData } from "@/lib/types/api/stations-data";

// components
import MarbleHallMurdersPromoBadge from '@/components/PromoBadge/MarbleHallMurdersPromoBadge';
import MarlowMurderClubPromoBadge from '@/components/PromoBadge/MarlowMurderClubPromoBadge';

interface Sept2026PromoBadgePickerProps {
  stationData: StationData;
}

const Sept2026PromoBadgePicker = (props: Sept2026PromoBadgePickerProps) => {
  const { stationData } = props;

  // Lazy initializer: runs once on mount, so the pick is stable across re-renders
  const [showMarbleHall] = useState(() => Math.round(Math.random()) === 1);

  return showMarbleHall
    ? <MarbleHallMurdersPromoBadge stationData={stationData} />
    : <MarlowMurderClubPromoBadge stationData={stationData} />;
};

export default Sept2026PromoBadgePicker;
